import dataProvider from "src/dataProvider";

const fetcher = dataProvider("adminInstance");

export type NewKmlThread = {
  epid: string;
  newKmlStatus: "PENDING_REVIEW" | "UNDER_QUERY" | "APPROVED" | null;
  isLocked: boolean;
  originalKml: { key: string | null; url: string | null };
  newKml: { key: string | null; url: string | null } | null;
  thread: {
    id: string;
    comment: string;
    action: "IO_SUBMISSION" | "ADMIN_QUERY" | "ADMIN_APPROVED";
    authorSubType: string;
    authorUserName: string;
    createdAt: string;
  }[];
};

export const getNewKmlThread = (epid: string) =>
  fetcher.get<NewKmlThread>(`/projects/land-ownership/new-kml/${epid}`);

export const submitNewKml = (
  epid: string,
  body: { fileKey: string; comment: string }
) => fetcher.post(`/projects/land-ownership/new-kml/${epid}`, body);
